import {
  getDefaultConfig,
  getDefaultWallets,
  WalletList,
} from '@rainbow-me/rainbowkit'
import {
  coinbaseWallet,
  coreWallet,
  okxWallet,
  trustWallet,
} from '@rainbow-me/rainbowkit/wallets'
import { createPublicClient, defineChain, http } from 'viem'
import {
  arbitrum,
  base,
  linea,
  mainnet,
  optimism,
  polygon,
  zksync,
} from 'viem/chains'

export const sonic = defineChain({
  id: 146,
  name: 'sonic',
  network: 'sonic',
  nativeCurrency: {
    name: 'Sonic',
    symbol: 's',
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [
        'https://sonic-mainnet.g.alchemy.com/v2/sL6jWEuf31251PpMF2raljfV-RRyax_i',
        'https://sonic.drpc.org',
        'https://sonic-rpc.publicnode.com',
      ],
    },
    public: {
      http: [
        'https://sonic-mainnet.g.alchemy.com/v2/sL6jWEuf31251PpMF2raljfV-RRyax_i',
        'https://sonic.drpc.org',
        'https://sonic-rpc.publicnode.com',
      ],
    },
  },
  blockExplorers: {
    default: {
      name: 'Sonic',
      url: 'https://sonic-mainnet.g.alchemy.com/v2/sL6jWEuf31251PpMF2raljfV-RRyax_i',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 11_907_934,
    },
  },
})

const WALLET_CONNECT_PROJECT_ID = '7c492019a90462c70a242dadd08f5a66'
const APP_NAME = 'RFX'

export const publicClient = (chainId: any) =>
  createPublicClient({
    chain: chainId,
    transport: http(''),
  })

const { wallets } = getDefaultWallets({
  appName: APP_NAME,
  projectId: WALLET_CONNECT_PROJECT_ID,
})

export const walletList: WalletList = [
  ...wallets,
  {
    groupName: 'Others',
    wallets: [coinbaseWallet, trustWallet, coreWallet, okxWallet],
  },
]

export const WHITELISTED_CHAINS = [zksync, sonic]

export const rainbowKitConfig = getDefaultConfig({
  appName: APP_NAME,
  projectId: WALLET_CONNECT_PROJECT_ID,
  chains: [arbitrum, base, linea, mainnet, optimism, polygon, zksync, sonic],
  transports: {
    [sonic.id]: http(
      'https://sonic-mainnet.g.alchemy.com/v2/sL6jWEuf31251PpMF2raljfV-RRyax_i',
    ),
    [zksync.id]: http(),
    [arbitrum.id]: http(),
    [base.id]: http(),
    [linea.id]: http(),
    [mainnet.id]: http(),
    [optimism.id]: http(),
    [polygon.id]: http(),
  },
  wallets: walletList,
  ssr: true,
})
